import React from "react";
import styled from "styled-components";
import type { Position } from "../../../models/Position";
import PdfOverlayBox from "./PdfOverlayBox";
import { theme } from "../../../theme";

interface MaskOverlayProps {
  position: Position;
  pdfHeight: number;
  scale: number;
  onChange?: (pos: Position) => void;
  isActive?: boolean;
  isToggled?: boolean;
  onActivate?: () => void;
  isDraggable?: boolean;
}

const MaskBoxDiv = styled.div<{
  isActive: boolean;
  isToggled: boolean;
  notDraggable?: boolean;
}>`
  width: 100%;
  height: 100%;
  border: ${({ isActive, isToggled, notDraggable }) => {
    if (notDraggable) return `1px solid ${theme.colors.purple}`;
    if (isActive && isToggled) return "2px solid #E48FB1";
    if (isToggled) return "1px solid #E48FB1";
    return "1px solid rgba(161, 172, 188, 0.6)";
  }};
  background-color: ${({ notDraggable }) => {
    if (notDraggable) return theme.colors.purple;
    return "white";
  }};
`;

const MaskOverlay: React.FC<MaskOverlayProps> = ({
  position,
  pdfHeight,
  scale,
  onChange,
  isActive = true,
  isToggled = true,
  onActivate,
  isDraggable,
}) => {
  const interactive = isDraggable ?? isActive;
  return (
    <PdfOverlayBox
      defaultPosition={position}
      pdfHeight={pdfHeight}
      scale={scale}
      onChange={onChange}
      isDraggable={interactive}
      isResizable={interactive}
    >
      <MaskBoxDiv
        isActive={isActive}
        isToggled={isToggled}
        onClick={(e) => {
          e.stopPropagation();
          onActivate?.();
        }}
        notDraggable={isDraggable === false}
      />
    </PdfOverlayBox>
  );
};

export default MaskOverlay;
